const ShareIcon = ({ color, Text, textColor, isHovered, width, height, hoveredColor }) => {
  return (
    <>
      <div
        style={{
          display: "Flex",
          alignItems: "center", 
          width: { width },
          height: { height },
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="24"
          viewBox="0 0 22 24"
          fill="none"
        >
          <path
            d="M17.3281 15.5625C16.0601 15.5625 14.9211 16.1249 14.147 17.0132L8.58781 13.616C8.783 13.1307 8.89062 12.6011 8.89062 12.0469C8.89062 11.4903 8.78202 10.9586 8.58533 10.4717L14.1515 6.99173C14.9254 7.8772 16.0625 8.4375 17.3281 8.4375C19.6543 8.4375 21.5469 6.54497 21.5469 4.21875C21.5469 1.89253 19.6543 0 17.3281 0C15.0019 0 13.1094 1.89253 13.1094 4.21875C13.1094 4.77534 13.218 5.307 13.4147 5.79394L7.8485 9.27389C7.07459 8.38842 5.9375 7.82812 4.67188 7.82812C2.34566 7.82812 0.453125 9.72066 0.453125 12.0469C0.453125 14.3731 2.34566 16.2656 4.67188 16.2656C5.93989 16.2656 7.07891 15.7032 7.85295 14.8149L13.4122 18.2122C13.217 18.6975 13.1094 19.227 13.1094 19.7812C13.1094 22.1075 15.0019 24 17.3281 24C19.6543 24 21.5469 22.1075 21.5469 19.7812C21.5469 17.455 19.6543 15.5625 17.3281 15.5625ZM17.3281 1.40625C18.8789 1.40625 20.1406 2.66794 20.1406 4.21875C20.1406 5.76956 18.8789 7.03125 17.3281 7.03125C15.7773 7.03125 14.5156 5.76956 14.5156 4.21875C14.5156 2.66794 15.7773 1.40625 17.3281 1.40625ZM4.67188 14.8594C3.12106 14.8594 1.85938 13.5977 1.85938 12.0469C1.85938 10.4961 3.12106 9.23438 4.67188 9.23438C6.22269 9.23438 7.48438 10.4961 7.48438 12.0469C7.48438 13.5977 6.22269 14.8594 4.67188 14.8594ZM17.3281 22.5938C15.7773 22.5938 14.5156 21.3321 14.5156 19.7812C14.5156 18.2304 15.7773 16.9688 17.3281 16.9688C18.8789 16.9688 20.1406 18.2304 20.1406 19.7812C20.1406 21.3321 18.8789 22.5938 17.3281 22.5938Z"
            fill={isHovered ? hoveredColor : color}
          />
        </svg>
        <span className="popover-label" style={{ marginLeft: "8px" , color:textColor}}>
          {Text}{" "}
        </span>
      </div>
    </>
  );
};
export default ShareIcon;
